import { defineLazyL10n } from '$lib/i18n';
import { ns as componentsNs, preload as preloadComponents } from '$lib/components/_i18n';
import enUS from './locales/en-US.json';

const NS = 'login';
const loaders = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json');

export const { l10n, preload } = defineLazyL10n(loaders, NS, enUS, [
	{ ns: componentsNs, preload: preloadComponents },
]);
